import AppLegals from '../../components/AppLegals/AppLegals.vue'
import AppFooter from '../../components/AppFooter/AppFooter.vue'

export default {
    components: {
        AppLegals,
        AppFooter
    }
}
